export const optionsConciliados = [
  { label: 'Com', value: 0 },
  { label: 'Sem', value: 1 },
  { label: 'Somente', value: 2 },
];
